module.exports = __webpack_public_path__ + "img/date@2x.c725a0b.jpg";